
export { 후기최대갯수 } from "/vercel/path0/packages/shared-values/src/constants/academy/academy.ts"